module.exports = __webpack_public_path__ + "img/trial2-3.e9bab030.png";